export const priceFormatter = new Intl.NumberFormat('it-IT', {
  currency: 'EUR',
  style: 'currency',
})

export const formatPrice = (price: number) => {
  return priceFormatter.format(price)
}
